import findColorShadeInPalette from '../../../common/utils/find-color-shade-in-palette';
import reduceColorPointByStep from '../../../common/utils/reduce-color-point-by-step';
import checkShade from '../../../common/utils/check-shade';

const dark = (params) => {
  const { backgroundColor, backgroundColorPalette } = params;
  const fallback = {
    rule: 'dropdown.listPlateBackground.dark',
    params,
  };
  const targetShade = findColorShadeInPalette(backgroundColor, backgroundColorPalette);

  if (checkShade(targetShade, (shade) => shade >= 200)) {
    return reduceColorPointByStep({
      targetColor: backgroundColor,
      targetColorPalette: backgroundColorPalette,
      step: 1,
      fallback,
    });
  }
  return backgroundColorPalette[100];
};

export default dark;
